import $ from 'jquery'

$(document).ready(dhsv_vc_template_element())

function dhsv_vc_template_element() {}
